module.exports = __webpack_public_path__ + "img/web3icon6.37ae06ab.png";